/* eslint-disable no-unused-vars */
import { DateRange, Event } from '@material-ui/icons';
import moment from 'moment-timezone';
import React from 'react';
import 'react-contexify/dist/ReactContexify.css';
import { convertTimeZone, toSTime, } from '../../../../commons/utils/DateFormatter';
import { EventWrapper, ShortCodeWrapper } from './CustomEvent.Styles';
export var CustomEvent = function (_a) {
    var event = _a.event;
    var occurrenceType = event.event.occurrenceType;
    var title = function () {
        var title = '';
        var start = new Date(convertTimeZone(event.event.start, moment.tz.guess(), event.event.timeZone));
        var end = new Date(convertTimeZone(event.event.end, moment.tz.guess(), event.event.timeZone));
        if (event) {
            title = toSTime(start) + " " + event.title;
        }
        return title;
    };
    var shortCode = function () {
        return event.event.prjacc ? event.event.prjacc.shortCode : '';
    };
    var colorCode = function () { return (event.event.prjacc ? event.event.prjacc.color : ''); };
    return (React.createElement(EventWrapper, null,
        React.createElement("div", null, occurrenceType === 'single' ? (React.createElement(Event, { style: { fontSize: 10 } })) : (React.createElement(DateRange, { style: { fontSize: 10 } }))),
        React.createElement("p", null,
            event.event.prjacc && (React.createElement(ShortCodeWrapper, { color: colorCode() },
                ' ', shortCode() + ": ")), "" + title())));
};
//# sourceMappingURL=CustomEvent.js.map